import IResult, { ResultType } from "./IResult";

export default class PermissionDeniedResult<T> implements IResult<T> {
    data: T = null;
    resultType: ResultType = "PermissionDenied";
    errors: string[];

    constructor(error: string = "You do not have permission to perform this action.") {
        this.errors = [error];
    }
}
